'use strict';

var RouteModuloBaseMixin = require("moduleFold/modulobase/scripts/mixins/RouteModuloBaseMixin");


/**
 * Registrazione delle route per il modulo bss/gruppiutenti
 *
 * @class
 * @param {type} $stateProvider
 * @param {type} $urlRouterProvider
 * @param {type} $locationProvider
 */

function GruppiutentiRoutes($stateProvider, $urlRouterProvider, $locationProvider){

  var self = {
        $stateProvider: $stateProvider,
        stato: "gruppiutenti",
        url: "/gruppiutenti?da&a", 
        template: require("../templates/maintpl.html"),
        controller: ["$http", "$q", "$timeout", "$state", "$stateParams", "DSCfgFactory", "GridCfgFactory", "ToolbarSrv", "identifica", "$scope", "ActionFactory", "ErrorManager", "GruppiutentiFunzioniAggiuntive", require("../GruppiutentiCtrl")],
        //controllerAs
        //middleware
        //data
        //identifica
    };

    angular.extend(self, RouteModuloBaseMixin.prototype);
    self.registra();
}

module.exports = GruppiutentiRoutes;
